const $inject = ['$q', '$http', 'apiService'];

const locationsSearchService = function ($q, $http, apiService) {
  let service = {};
  service.get = get;
  service.getPoiFromSearchLocation = getPoiFromSearchLocation;

  function get(params) {
    const deferred = $q.defer();
    const apiUrl = apiService.getUrl('locations');

    $http.get(apiUrl, { params: params })
      .then((response) => {
        deferred.resolve(response.data);
      }).catch(() => {
      deferred.reject();
    });

    return deferred.promise;
  }

  function getPoiFromSearchLocation(searchLocation) {
    return _.extend({}, searchLocation, {
      Title: searchLocation.Name,
      City: {
        Code: searchLocation.Code
      }
    });
  }

  return service;
};

locationsSearchService.$inject = $inject;

export default locationsSearchService;


// WEBPACK FOOTER //
// ./src/services/locationsSearchService.js